export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Name of the exercise group leader:",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "The exercise tasks were clearly understandable.",
			},
			{
				id: 3,
				text: "The requirements in the exercise were appropriate.",
			},
			{
				id: 4,
				text: "Exercise and lecture were well coordinated.",
			},
			{
				id: 5,
				text: "Questions were answered without any problems.",
			},
			{
				id: 6,
				text: "The exercise group leader was able to convey the content well.",
			},
			{
				id: 7,
				text: "The exercise group leader was well prepared for each exercise.",
			},
			{
				id: 8,
				text: "The exercise group leader is responsive enough to questions.",
			},
			{
				id: 9,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 10,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 11,
				text: "The online appointments were well organized.",
			},
			{
				id: 12,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 13,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 14,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 15,
				text: "The course is an example of good digital education.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 16,
				text: "Remarks on the exercise group:",
			},
		],
	},
];
